import { render, staticRenderFns } from "./express_edit.vue?vue&type=template&id=61127a51&scoped=true"
import script from "./express_edit.vue?vue&type=script&lang=ts"
export * from "./express_edit.vue?vue&type=script&lang=ts"
import style0 from "./express_edit.vue?vue&type=style&index=0&id=61127a51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61127a51",
  null
  
)

export default component.exports